export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xGIzIXKMnyrYk.07f6763b.woff2";